// extracted by mini-css-extract-plugin
export default {"pill":"BetaPill_pill__64Tpk"};